import { all, takeEvery, put, call, fork } from "redux-saga/effects";
import { notification } from "@iso/components";
import UserApi from "@iso/lib/api/userHelper";
import actions from "./actions";
import { PermissionUserManagement } from "../../config";
import { redirectPage, getDataFromToken } from "@iso/lib/helpers/utility";
var UserDetails = getDataFromToken();
var roleOfUser = UserDetails.role;
export function* userCreateRequest() {
  yield takeEvery(actions.USER_ADD_NEW, function* ({ payload }) {
    console.log("payloaddddd", payload);
    const result = yield call(UserApi.create, payload.dataObj);
    console.log("resulttttttpayload", result);
    if (result.status === 0) {
      notification("error", result.message);
    } else {
      console.log("payload.dataObj", "200");
      notification("success", result.message);
      yield put({
        type: actions.USER_READ,
        success: true,
        msg: result.message,
      });
      if (payload.dataObj.type && payload.dataObj.type === "editPage") {
        payload.history.push("/dashboard/categorytree");
      } else {
        // window.location.reload(true);
        window.location.href = "/dashboard/userlist";
        // payload.history.push('/dashboard/userlist');
      }
    }
  });
}

export function* userReadRequest() {
  yield takeEvery(actions.USER_READ, function* ({ payload }) {
    console.log("payloadddddRead", payload);
    try {
      const searchResult = yield call(UserApi.read, payload.readFilter, payload.page);
      console.log("payloadddddsearchResult", searchResult);
      if (!PermissionUserManagement.includes(roleOfUser)) {
        redirectPage("/404");
      }
      if (searchResult.status) {
        yield put(actions.userReadSearchSuccess(searchResult.result, true, searchResult.totalRecCount, payload.page, payload.readFilter));
      } else {
        notification("error", searchResult.message);
      }
    } catch (error) {
      console.log("Error::::::::::::::", error);
    }
  });
}

export default function* rootSaga() {
  yield all([fork(userCreateRequest), fork(userReadRequest)]);
}
